import { BlockDesktop as Block } from '@alfa-bank/site-block/desktop';
import { TextDesktop as Text } from '@alfa-bank/site-text-v2/desktop';
import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';

import type { IDeps, TWarranty } from './models';
import { Warranty as Component } from './warranty';
import styles from './styles/desktop.css';

export const Warranty = createWidget<IDeps, TWarranty>({
    Block,
    styles,
    Text,
})(Component);
